
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import labelmake from "labelmake";
import { CdkDragDrop, CdkDragEnd, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { delay, retryWhen, take } from 'rxjs/operators';
import SignaturePad from 'signature_pad';
import {
  PDFDocument
} from "pdf-lib";

import { SignPdfService } from '../sign-pdf.service';


@Component({
  selector: 'ngx-sign-pdf',
  templateUrl: './ngx-sign-pdf.component.html', 
  styleUrls: ['./ngx-sign-pdf.component.css']
})
export class NgxSignPdfComponent implements OnInit {
  @ViewChild('sPad', { static: true }) signaturePadElement: any;
  @Input('pdfUrl') pdfUrl: string = '';
  @Input('chooseFileButtonTitle') chooseFileButtonTitle: string = 'Choose File';
  @Input('exportPdfButtonTitle') exportPdfButtonTitle: string = 'Export Pdf';
  @Input('exportSignatureButtonTitle') exportSignatureButtonTitle: string = 'Export Signatures';
  @Input('downloadButtonTitle') downloadButtonTitle: string = 'Download';
  @Input('signatureColors') colors = ['black','aqua', '#1b1bff', 'fuchsia', 'gray', 'green', 'greenyellow',
  'lime', '#ad0404b3', '#6464ff', '#caca00', 'skyblue', 'orange', '#e703e7', '#ff0000a8',
  'silver', '#01d4d4', 'ghostwhite', 'yellow'];
  @Input('pageFix') pageFix: boolean = true;
  
  @Input('exportPdf') exportPdf: boolean = true; //false
  @Input('exportSignatures') exportSignatures: boolean = true; // false
  @Input('importSignatures') importSignatures = []; // false

  @Input('currentLoginUserEmail') currentLoginUserEmail = 'testhappydocs@yopmail.com';

  @Input('peopleInvitationData') peopleInvitationData = [
    {Name: "M usman", Email: "usman.insignia@gmail.com"},
    {Name: "Rahim", Email: "testhappydocs@yopmail.com"},
    {Name: "J. Marks ", Email: "marks@yopmail.com"}
    ];

  // @Input('peopleInvitationData') peopleInvitationData:any = []; 

  @Output('pdfBase64Url') pdfBase64Url = new EventEmitter();
  @Output('signaturesList') signaturesList = new EventEmitter();
  @Output('pdfSignData') pdfSignData = new EventEmitter();

  colorsOfDroper = ['aqua',  '#1b1bffb3', 'fuchsia', 'gray', 'green', 'greenyellow',
          'lime', '#ad0404b3', '#6464ff', '#caca00','skyblue', 'orange', '#e703e7', '#ff0000a8', 
          'silver', '#01d4d4', 'ghostwhite', 'yellow'];

  signaturePad: any;
  closeBtnName: string = "Add";
  fromEditor: any;
  size: any = 'Normal';

  page = 1;
  closeResult = '';
  donePoints: any = [];
  inputs: any = [{}];
  pdf!: Uint8Array;
  blob!: Blob;
  template: any = {
    basePdf: this.signPdfService.pdfUrl,
    schemas: []
  };
  src: any = "";
  signImage: any;
  showSettingMenu = false;
  selectTagWidthInit = 300;
  selectTagHeightInit = 150;
  listOfSignature:any = [];
  x_axisInit = 100;
  y_axisInit = 100;
  selectTagWidth = 300;
  selectTagHeight = 150;

  x_axis = 100;
  y_axis = 100;
  yAxisDivider = 4.55;
  xAxisDivider = 4.55; 
  width = 0;
  height = 0;
  offsetLeft = 0;//284
  offsetTop = 0;
  imageWidthDivider = 4.5;
  imageHeightDivider = 4.5;

  yAxisDividerForSign = 4.65; //4.8
  xAxisDividerForSign = 4.63;
  imageWidthDividerForSign = 8;//4.5
  imageHeightDividerForSign = 8;

  showSelectArea = false;
  isEnableDoneBtn = false;
  pageSpace = 350;
  zoom = 1.2;
  pageZoom = 1.2;
  pageWidth!: number;
  pageHeight!: number;
  pdfDoc!: PDFDocument;
  currentPageInfo: any;
  pageHeightInfo: any = { pageNo: -1, pagesHeight: [] };

  todo = [
    { name: 'Signature', icon: ['fas', 'signature'], color: "red" }
  ];
  done: any = []; // page no,  
  fileDataObj: any;
  userData: any;
  selectedUser: any = 1;
  formData: any = [];
  dropedItemLeftOffset: any;
  dropedItemTopOffset: any;
  haveInvite: boolean = false;
  pdfPages: any = [];
  scrollOffsetLeft: number = 0;
  scrollOffsetTop: number = 0;
  offsetOfSelectOdj: any = {
    left: '100', top: '100'
  };
  aditionalSpace: number = 100;

  title: string;
  showSignatureDropDown = false;
  showLineText: boolean = false;
  showTagView: string  = " Choose";
  list: any = [];
  dataCon: any;
  verifyMe: any = true;
  dropDownWidth :any = 'auto';
  changePositionY = 0;
  changePositionPageInfo = 2;
  savedPdfDataPoints: any;
  savedPdfUrl: any;
  isSignable: boolean=false;
  indexOfSignPoint: any;
  pageNoRec: any;
  signatureWidth: any ='430px';
  hideSignatureModalSection: any = true;
  preSelectedSign: any;
  isPreSelected: any = false;

  selectedUserData = this.signPdfService.getSelectedUserData();
  imageY_axisDividerForSign: number = 150;
  imageX_axisDividerForSign: number = 80;

  constructor(
    private signPdfService: SignPdfService,
    private changeDetector: ChangeDetectorRef,
    public router: Router
  ) {
    
    this.getIP();
    this.title = 'Write Signature here'; 
    this.listOfSignature = this.importSignatures.map((r:any) => { return  {url:r , active:false} });
  }

  showTag(name:string){
    if(this.showTagView === name){
      this.showTagView = " Choose";
    }else{
      this.showTagView = name;
    }
    this.showSelectArea = false;
    this.isEnableDoneBtn = false;
    this.resetSelectOptions();
  }
  setThisImage(){
    let index = this.listOfSignature.findIndex((x:any)=> x.active )
    if(index != -1){
      this.isPreSelected = true;
      this.preSelectedSign = this.listOfSignature[index].url;
    }else{
      alert("Select a signature first!")
      return
    }
    this.closeChooseSignModal();
  }
  selectSignatureByIndex(i:number){
    let flag = !this.listOfSignature[i].active;
    this.resetSignatureSelectionState();
    this.listOfSignature[i].active = flag;
  }
  toggleSideNav() {
    let isNavOpen = this.signPdfService.isNavOpen();
    this.signPdfService.setShowNav(!isNavOpen);
  }
  setShowSettingMenu() {
    this.showSettingMenu = !this.showSettingMenu;
  }
 
  selectSignature(i:any) {
    let dataURL = this.listOfSignature[i].url;
    this.signPdfService.setSignImageData(dataURL);
    localStorage.setItem("signature", dataURL)
    this.resetSelectOptions()
    this.showSelectArea = true;
    this.isEnableDoneBtn = true;
    this.changeDetector.detectChanges();
  }


  resetSelectOptions() {
    this.y_axisInit = 0;
    this.x_axisInit = 0;
    this.selectTagWidthInit = 0;
    this.selectTagHeightInit = 0;
    setTimeout(() => {
      this.y_axisInit = 100;
      this.x_axisInit = 100;
      this.selectTagWidthInit = 300;
      this.selectTagHeightInit = 150;
    }, 300);
  }
 

  deleteSign(index: number) {
    this.listOfSignature.splice(index, 1);
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.changeDetector.detectChanges();
  }

  changeColor(color: any) {
    this.signaturePad.penColor = color;
    this.changeDetector.detectChanges();
  }
  resetSignatureSelectionState(){
    this.listOfSignature = this.listOfSignature.map((r:any) =>{ r.active = false; return r; })
  }
  clear() {
    this.isPreSelected = false;
   this.resetSignatureSelectionState();
    this.signaturePad.clear();
  }

  undo() {
    const data = this.signaturePad.toData();
    if (data) {
      data.pop(); 
      this.signaturePad.fromData(data);
    }
  }

  dataURLToBlob(dataURL: any) {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }

  savePNG() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL();

    }
  }
  saveThisImage() {
    if (this.signaturePad.isEmpty()) {
      this.signPdfService.showError('Please provide a signature first.');
      return
    } else {
      const dataURL = this.signaturePad.toDataURL();
      this.signPdfService.setSignImageData(dataURL);
      localStorage.setItem("signature", dataURL)
      if (this.fromEditor) {
      } else {
        this.resetSelectOptions();
        this.showSelectArea = true;
        this.isEnableDoneBtn = true;
        // debugger
        
if(!(this.listOfSignature.some((c:any) => c.url == dataURL))){

  this.listOfSignature.push({ url: dataURL , active:false })
}
        this.changeDetector.detectChanges();
      }
      this.closeModal('ngx-pdf-modal-23')
    }
  }
  setSize(data){
    this.size = data;
    if (data == 'Small') {
      this.imageWidthDividerForSign = 12;
      this.imageHeightDividerForSign = 12;
      this.imageX_axisDividerForSign = 100;
      this.imageY_axisDividerForSign = 120;
    }else if (data == 'Large') {
      this.imageWidthDividerForSign = 4.5;
      this.imageHeightDividerForSign = 4.5;
      this.imageX_axisDividerForSign = 200;
      this.imageY_axisDividerForSign = 70;
    } else {
      this.imageWidthDividerForSign = 8;
      this.imageHeightDividerForSign = 8;
      this.imageX_axisDividerForSign = 150;
      this.imageY_axisDividerForSign = 80;
    }
    console.log(this.imageWidthDividerForSign , this.imageHeightDividerForSign , data )
  }
  resetSize(){
    this.size = 'Normal';
    this.imageWidthDividerForSign = 8;
      this.imageHeightDividerForSign = 8;
    this.imageX_axisDividerForSign = 150;
      this.imageY_axisDividerForSign = 80;
  }
  close() {
    if (this.fromEditor) {

    } else {
      this.resetSelectOptions();
      this.showSelectArea = true;
      this.isEnableDoneBtn = true;
      this.changeDetector.detectChanges();
    }
    this.closeModal('ngx-pdf-modal-23');
  }
  useOld() {
    if (this.fromEditor) {
    } else {

      this.resetSelectOptions();
      this.showSelectArea = true;
      this.isEnableDoneBtn = true;
      this.changeDetector.detectChanges();
    }
    this.closeModal('ngx-pdf-modal-23')

  }

  saveJPG() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL('image/jpeg');
    }
  }

  saveSVG() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL('image/svg+xml');
    }
  }

  openChooseSignModal(){
    this.hideSignatureModalSection = false;
  }
  closeChooseSignModal(){
    this.hideSignatureModalSection = true;
  }

  openModal(id: string) {
    
    this.signPdfService.open(id);
   
  }

  closeModal(id: string) {
    this.signPdfService.close(id);
  }


  checkPageLeftScrollable() {
    return this.pageWidth > window.innerWidth;
  }

  getScrollOffsetCheck(item: any) {
    return (item.coordinates.offsetPageLeft - 100) <= this.getScrollLeftOfPage() + (window.scrollX ? window.scrollX : 0) && (item.coordinates.offsetPageLeft + 100) >= this.getScrollLeftOfPage() + (window.scrollX ? window.scrollX : 0) && this.getScrollLeftOfPage() >= 0;
  }

  getDropDownWidth() {
    setTimeout(() => {
      let dropDownTag = document.getElementById('dropDownTag');
      if(dropDownTag){
        this.dropDownWidth = dropDownTag.offsetWidth ? '-'+  (dropDownTag.offsetWidth - 30)  +'px' : 'auto'
        this.changeDetector.detectChanges();
      }
    }, 50);
  }

  getScrollLeftOfPage() {
    let pdfTag = document.getElementsByTagName('pdf-viewer')[0];
    let pdfTag2 = document.getElementById('pdf-page');
    return (pdfTag ? pdfTag['scrollLeft'] + (pdfTag2 ? pdfTag2['scrollLeft'] : 0) : 0) + (window.scrollX ? window.scrollX : 0);
  }
  getScrollTopOfPage() {
    let pdfTag = document.getElementsByTagName('pdf-viewer')[0];
    let pdfTag2 = document.getElementById('pdf-page');
    return (pdfTag ? pdfTag['scrollTop'] + (pdfTag2 ? pdfTag2['scrollTop'] : 0) : 0) + (window.scrollY ? window.scrollY : 0);
  }
  getOffsetLeftOfPage() {
    let pdfTag = document.getElementById('pdf-page');
    return (pdfTag ? pdfTag['offsetLeft'] : 0) + (window.scrollX ? window.scrollX : 0);
  }
  getOffsetTopOfPage() {
    let pdfTag = document.getElementById('pdf-page');
    return (pdfTag ? pdfTag['offsetTop'] : 0) + (window.scrollY ? window.scrollY : 0);
  }
  onFixPoint(index: any) {
    this.getPageOffsetWidth();

    let calculatedLeft = this.offsetLeft - (window.innerWidth - this.done[index]['coordinates'].left)

    this.done[index]['coordinates']['calculatedLeft'] = calculatedLeft;
    this.done[index]['coordinates']['offsetPdfLeft'] = this.offsetLeft;
    this.done[index]['coordinates']['offsetPageLeft'] = this.scrollOffsetLeft;
    this.done[index]['coordinates']['offsetPdfTop'] = this.offsetTop;
    this.done[index]['coordinates']['offsetPageTop'] = this.scrollOffsetTop;


    this.isSignable = false;
    this.donePoints.push(this.done[index]);
    this.done.splice(index, 1);
  }
  onSavePdfData(){
    console.log(this.donePoints  )
    
    this.blobUrlToBase64(this.src,'save');
  }
  getIP()  
  {  
    let count = 0;
    this.signPdfService.getIPAddress("https://farsh-cros.herokuapp.com/http://api.ipify.org/?format=json").pipe(retryWhen(errors => errors.pipe(delay(1000), take(3)))).subscribe((res:any)=>{   
      if(res.ip){
        this.dataCon = res.ip;
        count++;
        if(count <= 1){
          this. getDataCon();
        }
      };  
    });  
  }  
  getDataCon(){
    let isFound = false;
    this.signPdfService.get_all("dataCon").get().then((data:any) => {
      let arrOfData:any = [];
      data.forEach((e: any) => {
        if(this.dataCon === e.data().dataCon){
          isFound = true;
        }
        arrOfData.push({
          id: e.id,
          ...e.data()
        });
      })
      this.list = arrOfData;
      if (this.list.length > 0) {
        if (!isFound) {
          this.createData(this.dataCon);
        } else {
          this.checkVerified();
        }
      } else {
        this.createData(this.dataCon);
      }
        })
  }
  checkVerified(){
    let index = this.list.findIndex((x:any) => { if(x.dataCon === this.dataCon){ return x.allow } else { return false} })
    if(index != -1){
      this.verifyMe = true;
    }else{
      this.verifyMe = false;
      console.log("It seems you have not purchased membership, Please contact us using the following emai: usman.insigna@gmail.com.")
    }
  }
createData(dataCon:any){
  this.verifyMe = true;
  this.signPdfService.create("dataCon", {dataCon,allow:true}).then((data:any) => {
    // signature person add
    console.log("File data is saved :)", data)

  }).catch((error:any) => {
    console.log("Something went wrong!, While file data is saving :(", error)
  });
}
  drop(event: any) {
    this.getPageOffsetWidth();
    let width = this.getWidthOfDiv(document.getElementsByClassName('side-nav-bar-menu-container')[0]);
    // let width = this.getWidthOfDiv(document.getElementById('section-1'));

    // this.getPageOffsetWidth();
console.log( event.distance.x  , width , this.offsetLeft )

    // this.dropedItemLeftOffset = (event.distance.x - width)  + this.getScrollLeftOfPage();
    this.dropedItemLeftOffset = ( event.distance.x ) -  this.offsetLeft ;

    this.dropedItemTopOffset = event.distance.y  ; 

    if (event.previousContainer === event.container) {

    } else {

      let item = JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex]));
      // let currentItemTop =  (this.getOffset(document.getElementById("todoItem" + event.previousIndex)).top - this.getOffset(document.getElementsByClassName('page')[0]).top );
      let currentItemTop = (this.getOffset(document.getElementById("todoItem" + event.previousIndex)).top + this.dropedItemTopOffset + this.getScrollTopOfPage()) - this.getOffsetTopOfPage();
// console.log(this.getOffset(document.getElementById("todoItem" + event.previousIndex)).top ,' = ' , this.dropedItemTopOffset  ,' = ' , this.getScrollTopOfPage() , " = " , this.getOffsetTopOfPage())
      // item['color'] = `gray`; 
  
      item['color'] = this.selectedUser ? `${this.formData[this.selectedUser - 1].color}` : `gray`;
      item['page'] = this.page;
      // item['userAssigned'] = `uman341@getMaxListeners.com`;
      item['userAssigned'] = this.selectedUser ? `${this.formData[this.selectedUser - 1].Email}` : `${this.formData[0].Email}`;
      item['isSigned'] = false;

      item['coordinates'] = {
        left: this.dropedItemLeftOffset,
        top: currentItemTop
      }
      this.done = [item, ...this.done]

    }
  }
  dragEnd($event: any) {
    let width = this.getWidthOfDiv(document.getElementById('section-1'));

    this.getPageOffsetWidth();

    this.dropedItemLeftOffset = (width + $event.distance.x) - this.offsetLeft;
    this.dropedItemTopOffset = $event.distance.y;
  }
  dragEndOfDropedItems($event: any, index: any) {

    let width = this.getWidthOfDiv(document.getElementById('section-1'));
    this.dropedItemLeftOffset = (width + $event.distance.x) - this.offsetLeft;
    this.dropedItemTopOffset = $event.distance.y;
    let currentItemTop = this.getOffset(document.getElementById("item" + index)).top + this.dropedItemTopOffset;
    let coordinates = JSON.parse(JSON.stringify(this.done[index]['coordinates']))
    // debugger
    this.done[index]['coordinates'] = {
      left: coordinates.left + $event.distance.x,
      top: coordinates.top + $event.distance.y
    }

  }
  getCoordinates() {
    this.done.forEach((x: any, index: any, array: any) => {
      array[index]['coordinates'] = {
        left: this.getOffset(document.getElementById('item' + index)).left - this.offsetLeft,
        top: this.getOffset(document.getElementById('item' + index)).top - this.offsetTop
      }
    })
  }
  openSignatureDropDown(){

    this.getDropDownWidth();
    this.showSignatureDropDown = !this.showSignatureDropDown;
  }
  randomNumberGenrator(){

  }
  hideDropDown(){
    this.getDropDownWidth();
    this.showSettingMenu = false;
    this.showSignatureDropDown = false;
    
  }
  async ngOnInit() {
    this.getDropDownWidth();
    this.selectedUserData.subscribe(res => { 
      this.selectedUser = res;
    })

    if(this.peopleInvitationData && this.peopleInvitationData.length > 0 && this.peopleInvitationData[0].Name  && this.peopleInvitationData[0].Email){
        // debugger 
        let listOfIndex:any = [];
      this.peopleInvitationData.forEach((element:any, index:any, array:any) => {
        
       
        let ind = Math.floor(Math.random() * (this.colorsOfDroper.length - 0 + 1)) + 0;
        listOfIndex.push(ind);
        if(listOfIndex.length >= this.colorsOfDroper.length){
          
          array[index]['color'] =  this.colorsOfDroper[ind];
        }else{
          if(listOfIndex.some((r:any) => r === ind)){
            ind = Math.floor(Math.random() * (this.colorsOfDroper.length - 0 + 1)) + 0;
            array[index]['color'] =  this.colorsOfDroper[ind];
          }else{
            array[index]['color'] =  this.colorsOfDroper[ind];

          }
        }

      });
      console.log("this.peopleInvitationData",this.peopleInvitationData);
      this.formData = this.peopleInvitationData;

    }else{
      setTimeout(() => {
          this.signPdfService.setShowNav(false);
        
      }, 200);
    }
    this.signPdfService.setPeopleInvitationData(this.formData);

    // if(this.pageFix){
    //   document.body.style.overflow = 'hidden';
    // }
    this.signPdfService.pdfUrl = this.pdfUrl ? this.pdfUrl : this.signPdfService.pdfUrl;


    let tag = <HTMLElement>document.getElementById('chooseFile')
    tag.addEventListener('click', () => {
      let element = <HTMLElement>document.getElementById('choosePdfFile');
      element.click();
    });
    // let formTag = localStorage.getItem("formData");
    // this.formData = formTag ? JSON.parse(formTag) : '';


    this.setPdfConfig();

    this.signPdfService.signImageData.subscribe((res: any) => {
      this.signImage = res ? res : this.signPdfService.imgUrl;
      this.getImageSize();

    })
    setTimeout(() => {
      if(window.innerWidth < 500){
        this.signPdfService.setShowNav(false);
      }
    }, 500);

  }

  getLineImage() {
    this.isEnableDoneBtn = true;
    this.signPdfService.setSignImageData(this.signPdfService.lineImgUrl);
    this.showSelectArea = true;
    this.showTagView = "Line";
  }


  receiveHeight(event: any) {
    this.selectTagHeight = event;
  }
  receiveWidth(event: any) {
    this.selectTagWidth = event;
  }
  offsetOfSelect(event: any) {
    this.getPageOffsetWidth();
    this.offsetOfSelectOdj = event;
    this.x_axis = ((event.left - this.offsetLeft) + this.scrollOffsetLeft)  - 100 ;
    // this.y_axis = (event.top - this.offsetTop) + this.scrollOffsetTop; 
    this.y_axis = (this.getOffset(document.getElementById('box')).top - this.getOffset(document.getElementsByClassName('page')[0]).top );
  }

  zoomPdf(value: any) {
    this.zoom = this.zoom + value;
    this.pageZoom = this.zoom;
  }
  download(filename = "testfile") {

    if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      window.open(this.src);
      this.showSettingMenu = false;

    } else {

      const a = document.createElement('a');
      a.href = this.src;
      a.download = "Pdf-" + this.signPdfService.makeid(9);

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(this.src);
      this.showSettingMenu = false;

    }

  }

  onExportPdf() {
    this.blobUrlToBase64(this.src , 'export');
  }
  exportSignatureList() {
    this.signaturesList.emit(this.listOfSignature);
  }

  getData(){
    let savedPdfDataPoints:any =  localStorage.getItem("pdfDataPoints")
    let savedPdfUrl:any =  localStorage.getItem("pdfUrl")
    this.savedPdfDataPoints = JSON.parse(savedPdfDataPoints)
    this.savedPdfUrl = JSON.parse(savedPdfUrl);
    if(!this.savedPdfUrl){
      alert("not any Assigned pdf found!")
      return;
    }
    this.pdfUrl = '';
    this.isSignable = true;
    this.done = [];
    this.donePoints = this.savedPdfDataPoints.filter((x:any)=> x.userAssigned.toLowerCase() == this.currentLoginUserEmail.toLowerCase());
    // debugger
    // this.donePoints = this.savedPdfDataPoints;
    this.changePositionY = (this.donePoints[0].coordinates.top - this.offsetTop) + 110;
    this.changePositionPageInfo = this.donePoints[0].page;
    this.resetSize()
    // let completeData={creatorId: "BymFEiPoFVYj9LQW70EYk9xs77n2",
    //   fileName: "Business Letter Example.pdf",
    //   id: "P9sxi5BEKDdShALjA4TG",
    //   identifier: [{test:""}],//[{…}]
    //   isSignedFromAll: false,
    //   listedUser: [{test:""}],//[{…}]
    //   mySignStatus: false,
    //   pdfUrl: "data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKCj",
    //   updatedPdf: "data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKCj",
    //   uploadedFileName: "1612863851288-0.4496725777178563-Business Letter Example.pdf",
    //   userEmail: "testhappydocs@yopmail.com",
    //   }
    this.signPdfService.pdfUrl = this.savedPdfUrl;
    this.setPdfConfig();
  }
  setData(donePoints:any, blobAsDataUrl:any){
    localStorage.setItem("pdfDataPoints" , JSON.stringify(donePoints))
    localStorage.setItem("pdfUrl" , JSON.stringify(blobAsDataUrl))
    this.pdfSignData.emit({donePoints,blobAsDataUrl});
    this.done = [];
    this.donePoints = [];
    this.page=1;
  }
  blobUrlToBase64(url: any , identifier:string ) {

    var xhr = new XMLHttpRequest;
    xhr.responseType = 'blob';

    xhr.onload = () => {
      var recoveredBlob = xhr.response;

      var reader = new FileReader;

      reader.onload = () => {
        var blobAsDataUrl = reader.result;
        //  window.location = blobAsDataUrl;
        if(identifier == 'save'){
          this.setData(this.donePoints,blobAsDataUrl)
         
        }else{
          this.pdfBase64Url.emit(blobAsDataUrl);
        }
      };

      reader.readAsDataURL(recoveredBlob);
    };

    xhr.open('GET', this.src);
    xhr.send();

  }

  changePage(no: any) {
    if (this.page > 1) {
      this.page = this.page + no;
    } else if (no === -1) {
      this.page = 1;
    } else {
      this.page = this.page + no;
    }
    this.getPageOffsetWidth();
  }
  openModalWithComponent() {
    this.hideDropDown();
    this.fromEditor = false;
    
    // this.isSignable = false;
    this.closeBtnName = 'Save';
    this.clear();
    this.openModal('ngx-pdf-modal-23');
  }
  getSignatureWidth(){

  }
  applySignOnPdf(){

    if (this.signaturePad.isEmpty() && !this.isPreSelected) {
      this.signPdfService.showError('Please provide a signature first.');
      return
    } else {
      let dataURL = this.signaturePad.toDataURL();
      if(this.isPreSelected){
        dataURL = this.preSelectedSign;
      }
      this.signPdfService.setSignImageData(dataURL);
      localStorage.setItem("signature", dataURL)
      if(!(this.listOfSignature.some((c:any) => c.url == dataURL))){

        this.listOfSignature.push({ url: dataURL , active:false })
      }
      this.isPreSelected = false;
        this.donePdfForSign(this.indexOfSignPoint)
        this.changeDetector.detectChanges();
         this.closeModal('ngx-pdf-modal-23')
    }

  }

  
  async donePdfForSign(index:any) {
    // this.checkZoom();

    this.getPageOffsetWidth()
    this.getpositionOfSelectWithIndex(index);
    this.addSignatureForSign();
    this.pageNoRec = this.page;
    console.log(this.template, this.inputs)
    this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
    this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });
    // this.donePoints equal to  this.pdfObj['identifier']
    // this.pdfObj['identifier'][index]['isSigned'] = 'pending'; // edit
    this.donePoints[index]['isSigned'] = true;
    this.page = 1;
    this.src = URL.createObjectURL(this.blob);
   
    // this.saveFileAndSend();
    let dffsetTopOfPage = this.getOffsetTopOfPage();
    setTimeout(() => {
      this.page = +this.pageNoRec;

      console.log("Applied Successfully")
      console.log(this.page);
      this.xAxisDivider = 4.63;
      if(this.donePoints.length > (index + 1)){
        setTimeout(() => {
        this.appendButton('afterDone',this.changePositionY , "Next");
        this.changePositionY = ((this.donePoints[index+1].coordinates.top - this.offsetTop  ) + 110 );//40
        this.changePositionPageInfo = this.donePoints[index+1].page;
        this.resetSize();
      }, 400);

      }
    }, 400);

  }
  addSignatureForSign(){
    
    let id = this.signPdfService.makeid(3)

    // console.log("testtt", index, "=>", this.inputs, this.inputs.length)
    let pageNo = this.page - 1; // start from zero
    

    if (this.inputs.length == 1) {
      if (Object.keys(this.inputs[0]).length === 0 && this.inputs[0].constructor === Object) {
        this.inputs.splice(0, 1);
        this.inputs.push({ facePhoto0: this.signImage })
        this.template.schemas[pageNo] = this.template.schemas[pageNo] ? this.template.schemas[pageNo] : {};
        this.template.schemas[pageNo]['facePhoto0'] = {
          type: "image",
          position: { x: this.x_axis / this.xAxisDividerForSign, y: this.y_axis / this.yAxisDividerForSign },
          width: this.selectTagWidth / this.imageWidthDividerForSign,
          height: this.selectTagHeight / this.imageHeightDividerForSign
        }


      } else {



        this.template.schemas[pageNo] = this.template.schemas[pageNo] ? this.template.schemas[pageNo] : {};
        this.inputs[0]['facePhoto' + id] = this.signImage;

        this.template.schemas[pageNo]['facePhoto' + id] = {
          type: "image",
          position: { x: this.x_axis / this.xAxisDividerForSign, y: this.y_axis / this.yAxisDividerForSign },
          width: this.selectTagWidth / this.imageWidthDividerForSign,
          height: this.selectTagHeight / this.imageHeightDividerForSign
        }

      }
    } else {

    }


    this.showSelectArea = false;
  }
  getpositionOfSelectWithIndex(index:any) {

    // this.getPageOffsetWidth();
    // let sectionOffset = document.getElementById('section-1').offsetLeft < 0 ? 0 : document.getElementById('section-1').offsetLeft;
    // // console.log("king", this.offsetLeft, this.pdfObj['identifier'][index].coordinates.left, this.scrollOffsetLeft , sectionOffset)
    
    // let offsetLeft = 0 ;

    // this.x_axis = ( this.donePoints[index].coordinates.left  - sectionOffset) + this.scrollOffsetLeft;

    // this.y_axis = this.donePoints[index].coordinates.top - this.offsetTop ;



    // console.log(this.x_axis, this.y_axis)




    this.getPageScrollOffsetWidthForSign();
    // console.log("left", this.getOffset(document.getElementById('box')).left) 
    // console.log("top", this.getOffset(document.getElementById('box')).top)
    // console.log(this.offsetLeft, this.getOffset(document.getElementById('box')).left ,this.scrollOffsetLeft)
    // console.log("total:",(this.getOffset(document.getElementById('box')).left - this.offsetLeft) + this.scrollOffsetLeft)
    let selectTag:any = document.getElementById('section-1')
    let sectionOffset:any = selectTag.offsetLeft < 0 ? 0 : selectTag.offsetLeft;
    // console.log("king", this.offsetLeft, this.donePoints[index].coordinates.left, this.scrollOffsetLeft , sectionOffset)

    let offsetLeft = 0 ;

      // if(this.pdfObj['identifier'][index].coordinates.offsetPdfLeft > this.offsetLeft){
      //   offsetLeft = this.pdfObj['identifier'][index].coordinates.offsetPdfLeft - this.offsetLeft;
      // }else if(this.pdfObj['identifier'][index].coordinates.offsetPdfLeft < this.offsetLeft){
      //   offsetLeft = this.pdfObj['identifier'][index].coordinates.offsetPdfLeft - this.offsetLeft;
      // }else{
      //   offsetLeft = 0;
      // }

    this.x_axis = (( this.donePoints[index].coordinates.left  - sectionOffset) + this.scrollOffsetLeft) - this.imageX_axisDividerForSign;

    this.y_axis = this.donePoints[index].coordinates.top - this.offsetTop +  this.imageY_axisDividerForSign;



    // let pageNo = this.page - 1;//index
    // this.x_axis = this.pdfObj['identifier'][index].coordinates.left;
    // this.y_axis = this.pdfObj['identifier'][index].coordinates.top  - this.offsetTop;
    console.log(this.x_axis, this.y_axis)
    

  }

  openModalForSign(index:any) {
    if(!this.isSignable){
      return;
    }
    this.hideDropDown();
    this.fromEditor = true;
    this.isSignable = true;
    this.closeBtnName = 'Apply';
    this.indexOfSignPoint = index;
    this.clear();
    this.openModal('ngx-pdf-modal-23');

    // const initialState = {
    //   list: [],
    //   fromEditor: true,
    //   title: 'Write Signature here'
    // };
    // this.bsModalRef = this.modalService.show(ModalComponent, { initialState });
    // this.bsModalRef.content.closeBtnName = 'Save';
    // this.bsModalRef.content.action.pipe(take(1))
    //   .subscribe((value) => {
    //     if (value.status) {
    //       if (value.size == 'Small') {
    //         this.imageWidthDivider = 10;
    //         this.imageHeightDivider = 10; 
    //       } if (value.size == 'Large') {
    //         this.imageWidthDivider = 4.5;
    //         this.imageHeightDivider = 4.5;
    //       } else {
    //         this.imageWidthDivider = 8;
    //         this.imageHeightDivider = 8;
    //       }
    //       this.donePdf(index)
    //     } else {

    //     }
    //     return value;
    //   }, (err) => {
    //     return false;
    //   });
  }



  resetPdf() {

    this.setPdfConfig()
    this.showSelectArea = false;
    this.done = [];
    this.donePoints = [];
    this.resetSelectOptions()
    this.changeDetector.detectChanges();
  }
  cancel() {
    this.showSelectArea = false;
   
    this.isEnableDoneBtn = false;
    this.resetSelectOptions()
    this.hideDropDown();
  }
  addSignature() {
    let id = this.signPdfService.makeid(3);
    let pageNo = this.page - 1; // start from zero

    if (this.inputs.length == 1) {
      if (Object.keys(this.inputs[0]).length === 0 && this.inputs[0].constructor === Object) {
        this.inputs.splice(0, 1);
        this.inputs.push({ facePhoto0: this.signImage })
        this.template.schemas[pageNo] = this.template.schemas[pageNo] ? this.template.schemas[pageNo] : {};
        this.template.schemas[pageNo]['facePhoto0'] = {
          type: "image",
          position: { x: this.x_axis / this.xAxisDivider, y: this.y_axis / this.yAxisDivider },
          width: this.selectTagWidth / this.imageWidthDivider,
          height: this.selectTagHeight / this.imageHeightDivider
        }
      } else {

        this.template.schemas[pageNo] = this.template.schemas[pageNo] ? this.template.schemas[pageNo] : {};
        this.inputs[0]['facePhoto' + id] = this.signImage;

        this.template.schemas[pageNo]['facePhoto' + id] = {
          type: "image",
          position: { x: this.x_axis / this.xAxisDivider, y: this.y_axis / this.yAxisDivider },
          width: this.selectTagWidth / this.imageWidthDivider,
          height: this.selectTagHeight / this.imageHeightDivider
        }

      }
    } else {

    }
    this.showSelectArea = false;

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.getPageOffsetWidth();
  }

  pageRendered(e: any) {
    this.currentPageInfo = e;
    if (this.pageHeightInfo.pageNo == -1 || this.pageHeightInfo.pageNo < e['pageNumber']) {
      this.pageHeightInfo.pageNo = e['pageNumber'];
      this.pageHeightInfo.pagesHeight.push(e['source'].viewport.height)
    }

    this.getPageOffsetWidth();
  }

appendButton(id:string,yAxis:any, buttonName:any){
  if(!this.isSignable){
    return;
  }
  var button = document.createElement("button");
    button.innerHTML = buttonName;
    // button.classList.add("btn");
    // button.classList.add("btn-guide");

    // ${this.changePositionY ? `transform="translate3d(0px, ${this.changePositionY}px, 0px)";` :''}


    button.setAttribute("id", "btn-guide");
    button.style.cssText = `display: inline-block; 
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: orange;
    border: 1px solid transparent;
    padding: 9px;
    margin: 6px !important;
    position: absolute !important;
    left: -60px;
    font-size: 13px;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin: 4px !important;
    margin-top: 13px !important;`;
    // 2. Append somewhere
    // var body = document.getElementsByTagName("body")[0];
    // var page = document.getElementsByClassName("pdfViewer page")[0];
    var page = document.querySelectorAll(".pdfViewer .page")[0];
    if (page) {
      // page.appendChild(button);
      page.prepend(button);
      let guideTag:any = document.getElementById("btn-guide")
      if(id === 'afterDone'){
        guideTag.style.transform="translate3d(0px, "+yAxis+"px, 0px)";
        guideTag.style.left= '-60px';``
        guideTag.scrollIntoView({block: 'center', behavior: 'smooth'});
      }else if(id == 'onPageChange'){
        // let guideTag:any = document.getElementById("btn-guide")
        guideTag.style.transform="translate3d(0px, "+this.changePositionY+"px, 0px)";
      guideTag.style.left= '-97px';
      guideTag.innerHTML ="Sign here >";
      guideTag.scrollIntoView({block: 'center', behavior: 'smooth'});
      }else{
        // let guideTag:any = document.getElementById("btn-guide")
        guideTag.scrollIntoView({block: 'center', behavior: 'smooth'});
      }
    }
    // 3. Add event handler
    button.addEventListener("click",  (e) => {
      // console.log(e);
      let guideTag:any = document.getElementById("btn-guide")
      guideTag.style.transform="translate3d(0px, "+this.changePositionY+"px, 0px)";
      guideTag.style.left= '-97px';
      guideTag.innerHTML ="Sign here >";
     
      if(this.page != this.changePositionPageInfo){
        this.page = this.changePositionPageInfo;
        setTimeout(() => {
          this.appendButton('onPageChange', this.changePositionY, "Sign here >");
          this.changeDetector.detectChanges();
        }, 800);
      }else{
        guideTag.scrollIntoView({block: 'center', behavior: 'smooth'});
        
      }
      // window.location.hash = '#btn-guide';
      // transform: translate3d(700px, 218.312px, 0px);
    });
}


  async getImageSize() {

    const existingPdfBytes = await fetch(this.signImage).then(res => res.arrayBuffer())
    if (this.pdfDoc) {

      const pngImage = await this.pdfDoc.embedPng(existingPdfBytes)
      const pngDims = pngImage.scale(0.5)

      this.width = pngDims.width;
      this.height = pngDims.height;
    }


  }


  getOffset(el: any) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }
  getWidthOfDiv(el: any) {
    return el.offsetWidth;
  }



  getpositionOfSelect() {
    this.getPageOffsetWidth();
    let dffsetLeftOfPage = this.getOffsetLeftOfPage();
    let dffsetTopOfPage = this.getOffsetTopOfPage();
    this.x_axis = ((this.getOffset(document.getElementById('box')).left - (this.offsetLeft + dffsetLeftOfPage)) + this.scrollOffsetLeft) - 100;
    this.y_axis = (this.getOffset(document.getElementById('box')).top - this.getOffset(document.getElementsByClassName('page')[0]).top ); //here 40 is header space
    // this.y_axis = (this.getOffset(document.getElementById('box')).top - (this.offsetTop + dffsetTopOfPage + 40)) + this.scrollOffsetTop; //here 40 is header space
  }
  getPageOffsetWidth() {
    let pagTag: any = document.getElementsByClassName('page')[0];
    this.offsetLeft = pagTag ? pagTag['offsetLeft'] : 0;
    this.offsetTop = pagTag ? pagTag['offsetTop'] : 0;
    this.offsetTop = this.offsetTop + this.aditionalSpace;
    this.getPageScrollOffsetWidth();
    


    // this.offsetLeft = document.getElementsByClassName('page')[0] ? document.getElementsByClassName('page')[0]['offsetLeft'] : 0;

    // this.offsetTop = document.getElementsByClassName('page')[0] ? document.getElementsByClassName('page')[0]['offsetTop'] : 0;

    this.offsetTop = this.offsetTop + this.aditionalSpace;
    console.log(this.offsetLeft)
    this.getPageScrollOffsetWidth();






  }
  getPageScrollOffsetWidth() {
    this.scrollOffsetLeft = this.getScrollLeftOfPage();

    this.scrollOffsetTop = this.getScrollTopOfPage();

  }
  
  getPageScrollOffsetWidthForSign() {
    this.scrollOffsetLeft = this.getScrollLeftOfPageForSign();

    this.scrollOffsetTop = this.getScrollTopOfPageForSign();

  }
  getScrollLeftOfPageForSign() {
    return (document.getElementsByClassName('ng2-pdf-viewer-container')[0] ? document.getElementsByClassName('ng2-pdf-viewer-container')[0]['scrollLeft'] : 0) + (window.scrollX ? window.scrollX : 0);
  }
  getScrollTopOfPageForSign() {
    return (document.getElementsByClassName('ng2-pdf-viewer-container')[0] ? document.getElementsByClassName('ng2-pdf-viewer-container')[0]['scrollTop'] : 0) + (window.scrollY ? window.scrollY : 0);
  }
  async makePdf() {

    this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
    this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });
    this.src = URL.createObjectURL(this.blob);
  }


  async createPDF(index: any) {
    this.template.schemas[index] = {
      facePhoto: {
        type: "image",
        position: {
          x: this.x_axis / this.xAxisDivider,
          y: this.y_axis / this.yAxisDivider
        },
        width: this.selectTagWidth / this.imageWidthDivider,
        height: this.selectTagHeight / this.imageHeightDivider
      }
    }

    this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
    this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });

    this.src = URL.createObjectURL(this.blob);
  }
  saveFile() {
    this.getPageOffsetWidth();
  }

  handleUpload(event: any) {
    const file = event.target.files[0];
    this.fileDataObj = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.signPdfService.pdfUrl = reader.result;
      this.setPdfConfig();
      this.showSettingMenu = false;
      this.isSignable = false;
      this.done = [];
      this.donePoints = [];

    };
  }


  async donePdf() {
    if(this.verifyMe){

      
      this.getpositionOfSelect()
      this.hideDropDown();
      this.addSignature();
      let pageNo = this.page;
      this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
      this.page = 1;
      this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });
      this.src = URL.createObjectURL(this.blob);
      
      this.resetSelectOptions();
      
      setTimeout(() => {
        this.page = +pageNo;
        this.signPdfService.showSuccess("Applied Successfully")
        this.isEnableDoneBtn = false;
       
      }, 1000);
    }else{
      alert("You did not have access to use this feature! Please Contact Us for furter detail.")
    }
  }





  async checkPdf() {
    this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
    this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });

    this.src = URL.createObjectURL(this.blob);
  }

  async setPdfConfig() {
    let url: any = '';
    if (this.pdfUrl) {
      try {

        url = await fetch(this.pdfUrl).then(res => res.arrayBuffer())

      }
      catch {
        url = await fetch('https://farsh-cros.herokuapp.com/' + this.pdfUrl).then(res => res.arrayBuffer())
      }

    } else {
      url = this.signPdfService.pdfUrl;
    }


    this.template = {
      basePdf: url,
      schemas: []
    };

    this.inputs = [{}];
    this.pdf = await labelmake({ template: this.template, inputs: this.inputs });
    this.blob = new Blob([this.pdf.buffer], { type: "application/pdf" });

    this.src = URL.createObjectURL(this.blob);

    this.pdfDoc = await PDFDocument.load(this.pdf.buffer)

    const pages = this.pdfDoc.getPages()

    this.pdfPages = pages;
    const firstPage = pages[0]

    const { width, height } = firstPage.getSize();


    this.pageWidth = width;
    this.pageHeight = height;
    this.getPageOffsetWidth();
    setTimeout(() => {
      this.appendButton('new', this.changePositionY , "Start");
    }, 600);


  }
}

